<template>
  <div class="bg-gray-4 max-md:px-[20px] py-[70px] border-curve relative">
    <NuxtImg loading="lazy"
      src="https://turpal-web.fra1.cdn.digitaloceanspaces.com/assets/recipient1.svg"
      class="recipient-1"
    />
    <NuxtImg loading="lazy"
      src="https://turpal-web.fra1.cdn.digitaloceanspaces.com/assets/recipient2.svg"
      class="recipient-2"
    />
    <NuxtImg loading="lazy"
      src="https://turpal-web.fra1.cdn.digitaloceanspaces.com/assets/recipient3.svg"
      class="recipient-3"
    />
    <NuxtImg loading="lazy"
      src="https://turpal-web.fra1.cdn.digitaloceanspaces.com/assets/recipient4.svg"
      class="recipient-4"
    />

    <div class="text-primary-1 md:w-[540px] mx-auto text-center mb-[40px]">
      <div class="text-mobile-heading-2 md:text-heading-2 mb-5">
        {{ t("discover.recipientTitle") }}
      </div>
      <div class="text-paragraph-1 md:w-[80%] mx-auto">
        {{ t("discover.recipientDescription") }}
      </div>
    </div>
    <div class="flex max-md:flex-col justify-center gap-[20px] md:gap-[30px]">
      <div
        v-for="(item, index) in facetsLabels"
        :key="index"
        class="recipient-card"
        @click="handleViewAllProducts(item.slug)"
      >
        <img
          :src="item.photo_url"
          class="rounded-full size-[80px] md:size-[120px] md:mx-auto object-cover"
        />

        <div
          class="flex flex-col justify-center max-md:ltr:ml-2.5 max-md:rtl:mr-2.5"
        >
          <div
            class="text-primary-1 text-mobile-heading-4 md:text-heading-4 md:mt-5"
          >
            {{ item.value }}
          </div>
          <div class="text-mobile-heading-5 md:text-heading-5 text-gray-1 mt-2">
            {{ item.product_count }} {{ t("discover.experiences") }}
          </div>
        </div>
        <div class="arrow-btn">
          <icon-arrow-up class="ltr:rotate-90 !mb-0 text-gray-5" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import type { IFacetsLabels } from "../../types/general";
import { type PropType } from "vue";

defineProps({
  facetsLabels: { type: Array as PropType<IFacetsLabels[]>, required: true },
});

const localePath = useLocalePath();
const router = useRouter();
const emit = defineEmits(["scroll-to-activities"]);
const { t } = useI18n();

const handleViewAllProducts = (slug: string) => {
  router.push(
    localePath({
      name: "things-to-do-in-slug",
      query: { "perfect-for": slug },
    })
  );
  emit("scroll-to-activities");
};
</script>
<style scoped lang="scss">
.recipient-card {
  @apply bg-white md:w-[157px] md:h-[310px] rounded-full px-[10px] py-[10px] md:py-5 md:text-center max-md:flex max-md:items-center relative cursor-pointer;
  .arrow-btn {
    @apply bg-primary-2 size-[44px] md:size-[52px] rounded-full flex items-center md:mx-auto md:mt-5 justify-center max-md:absolute max-md:ltr:right-4 max-md:rtl:left-4;
  }
}
.recipient-1 {
  @apply absolute top-[20px] md:top-[50px] right-[10px] md:right-[65px] max-md:w-[50px] md:w-[66px];
}
.recipient-2 {
  @apply absolute max-md:bottom-[5px] md:top-[157px] right-[30px] md:right-[157px] max-md:rotate-90 max-md:w-[50px] md:w-[40px];
}
.recipient-3 {
  @apply absolute top-[20px] md:top-[136px] left-[10px] md:left-[152px] max-md:w-[55px] md:w-[72px];
}
.recipient-4 {
  @apply absolute left-[10px] md:left-[16px] bottom-[20px] max-md:w-[45px] md:w-[74px];
}
</style>
